exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-badge[data-v-cd176d68]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#d9d9d9;color:#fff;border-radius:100%;font-size:12px}.vc-badge.danger[data-v-cd176d68]{background:#f33}.vc-badge.success[data-v-cd176d68]{background:#4dc4ff}.vc-badge.info[data-v-cd176d68]{background:#999}.vc-badge.warn[data-v-cd176d68]{background:#ffa31a}", ""]);

// exports
